import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  showPopoverType: 0, // 0：初始化 1：提醒保存 2：提醒工程数量已超过限制
  isAnonymousSaving: false,
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SET_SHOW_POPOVER_TYPE:
      return {
        ...state,
        showPopoverType: action.data
      };
    case FJActionConstant.SET_ANONYMOUS_SAVE_STATUS:
      return  {
        ...state,
        isAnonymousSaving: action.value
      }
    default:
      return state;
  }
}
